import React from 'react';
import { Typography, Tooltip, Button } from 'antd';

const { Paragraph } = Typography;

interface AssessmentCardProps {
  id: string;
  name: string;
  isLocked: boolean;
  isComplete?: boolean;
  isReattemptEnabled?: boolean;
  onAssesmentCardClick: (assesmentId: string) => void;
  onReattemptClick?: (assesmentId: string) => void;
  imgSrc: string;
  className?: string;
  showToolTip?: boolean;
}

/**
 * AssessmentCard component displays a card for an assessment with options
 * to attempt or reattempt the assessment based on its state.
 */
const AssessmentCard: React.FC<AssessmentCardProps> = ({
  id,
  name,
  isLocked,
  isComplete,
  isReattemptEnabled,
  imgSrc,
  onAssesmentCardClick,
  onReattemptClick,
  className = '',
  showToolTip = false,
}) => {
  // Handlers
  const handleCardClick = () => {
    if (!isLocked) {
      onAssesmentCardClick(id);
    }
  };

  const handleReattemptClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent triggering the card click
    if (!isLocked && onReattemptClick) {
      onReattemptClick(id);
    }
  };

  // UI Components
  const titleContent = (
    <Paragraph
      className="title"
      style={{
        margin: 0,
        fontSize: '14px',
        fontWeight: 500,
        textAlign: 'center',
      }}
      ellipsis={{ rows: 2 }}
    >
      {name}
    </Paragraph>
  );

  const cardContent = (
    <>
      <img width={55} alt={`${name} icon`} src={imgSrc} />
      {showToolTip ? (
        <Tooltip title={name} placement="top">
          {titleContent}
        </Tooltip>
      ) : (
        titleContent
      )}
    </>
  );

  return (
    <div style={{ textAlign: 'center', width: '141px' }}>
      <div
        className={`assessment-course-card ${className}`}
        style={{
          cursor: isLocked ? 'not-allowed' : 'pointer',
        }}
        onClick={handleCardClick}
        role="button"
        tabIndex={isLocked ? -1 : 0}
        aria-disabled={isLocked}
      >
        {cardContent}
      </div>

      {isReattemptEnabled && (
        <Button
          className="tab-button curved-border active"
          onClick={handleReattemptClick}
          disabled={isLocked}
        >
          Reattempt
        </Button>
      )}
    </div>
  );
};

export default AssessmentCard;
